import { render, staticRenderFns } from "./ClientTopBar.vue?vue&type=template&id=6d781124&scoped=true"
import script from "./ClientTopBar.vue?vue&type=script&lang=ts"
export * from "./ClientTopBar.vue?vue&type=script&lang=ts"
import style0 from "./ClientTopBar.vue?vue&type=style&index=0&id=6d781124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d781124",
  null
  
)

export default component.exports